import { Injectable, inject } from '@angular/core';

import { CookieService, DslService, OnFeatureInit } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { Cookie, CookieConfiguration } from './cookie-injector-model';
import { CookieInjectorConfig } from './cookie-injector.client-config';

@Injectable()
export class CookieInjectorBootstrapService implements OnFeatureInit {
    private config = inject(CookieInjectorConfig);
    private dslService = inject(DslService);
    private cookieService = inject(CookieService);

    async onFeatureInit() {
        await firstValueFrom(this.config.whenReady);
        Object.keys(this.config.cookieConfig).forEach((key) => {
            let cookieConfig = this.config.cookieConfig[key] as CookieConfiguration;
            if (cookieConfig?.condition) {
                this.dslService.evaluateExpression<boolean>(cookieConfig.condition).subscribe((isEnabled) => {
                    if (isEnabled) {
                        cookieConfig.cookies.forEach((c: Cookie) => {
                            const cookieOption = c.expiration ? { expires: new Date(new Date().getTime() + c.expiration) } : undefined;
                            this.cookieService.put(c.name, c.value, cookieOption);
                        });
                    }
                });
            }
        });
    }
}
